import { render } from "./HomeGallery.vue?vue&type=template&id=bc031c1e&scoped=true&lang=html"
import script from "./HomeGallery.vue?vue&type=script&lang=js"
export * from "./HomeGallery.vue?vue&type=script&lang=js"

import "./HomeGallery.vue?vue&type=style&index=0&id=bc031c1e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc031c1e"]])

export default __exports__